<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2 mat-dialog-title>{{ "pumps.connectedValves.form.title" | translate }}</h2>

  <mat-dialog-content>
    <app-input-wrapper
      [label]="'pumps.connectedValves.form.valves' | translate"
      [hint]="'pumps.connectedValves.form.hint' | translate"
      [control]="form.controls['connectedValveIds']"
    >
      <div class="w-full">
        <input
          type="search"
          formControlName="valveSearch"
          [placeholder]="'default.search' | translate"
          [matAutocomplete]="valveAuto"
        />

        <mat-chip-set class="selected-valve-chips">
          @for (valve of selectedValves$ | async; track valve.id) {
            <mat-chip removable="true" (removed)="removeValve(valve.id)">
              {{ valve.name }}
              @if (valve.isOutOfService) {
                <app-tag level="disabled">
                  {{ "devices.detail.outOfService.short" | translate }}
                </app-tag>
              }
              <button
                matChipRemove
                type="button"
                class="button icon-button small mat-chip-remove-button"
                [attr.aria-label]="'default.delete' | translate"
              >
                <app-icon name="ic_close" />
              </button>
            </mat-chip>
          }
        </mat-chip-set>
      </div>

      <mat-autocomplete
        #valveAuto="matAutocomplete"
        (optionSelected)="addValve($event.option.value)"
      >
        @for (valve of availableValves$ | async; track valve.id) {
          <mat-option [value]="valve.id">
            {{ valve.name }}
            @if (valve.isOutOfService) {
              <app-tag level="disabled">
                {{ "devices.detail.outOfService.short" | translate }}
              </app-tag>
            }
          </mat-option>
        } @empty {
          <mat-option disabled>{{ "devices.empty" | translate }}</mat-option>
        }
      </mat-autocomplete>
    </app-input-wrapper>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" class="button" mat-dialog-close>
      {{ "default.cancel" | translate }}
    </button>
    <button class="button primary-button" [disabled]="form.invalid">
      {{ "default.save" | translate }}
    </button>
  </mat-dialog-actions>
</form>
